import { createContext } from 'react';
import type { IarMember } from '@rsos/reduxDataStore/src/features/eventShare/types';

/**
 * Optional override consumed by IarAgencySelector. When a Provider supplies a
 * map of agencyId → IarMember[], the selector uses it instead of the live RTK
 * Query call. Intended for Storybook stories and future integration tests
 * where dispatching real network requests isn't feasible. Production callers
 * should never set this value.
 */
export const IarMockMembersContext = createContext<Record<
  number,
  IarMember[]
> | null>(null);
